module.exports = "<div class=\"col-sm-6 gallery-item\">\n    <a href=\"#\" class=\"gallery-target hover-outin\" [attr.data-cta]=\"cta\">\n        <imagePic [images]=\"(item | meta).images\"></imagePic>\n    </a>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/gallery/gallery-cell/gallery-cell.template.html
// module id = 743
// module chunks = 2